import AuthorizedUserService from './service';
import { AuthorizedUserResponse, BatchAuthorizedUsersPayload } from './types';
export class AuthorizedUserMutations {
  public static readonly bulkUpdateAuthorizedUsers = async ({
    requestId,
    version,
    payload,
  }: {
    requestId: number;
    version: number;
    payload: BatchAuthorizedUsersPayload;
  }): Promise<AuthorizedUserResponse> => {
    return await AuthorizedUserService.bulkUpdateAuthorizedUsers(requestId, version, payload);
  };
}
